import type { ConversationThreadResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface AttentiveThreadViewProps {
  thread: ConversationThreadResponse;
}

export const AttentiveThreadView = memo(function AttentiveThreadView({
  thread,
}: AttentiveThreadViewProps) {
  return <ChatThreadView channel="attentive" thread={thread} />;
});
